import Cookies from 'universal-cookie'
import TagManager from 'react-gtm-module'
import Orejime from 'orejime'

const defaultConfig = {
  elementID: 'orejime',
  appElement: '#root',
  apps: [
    {
      name: 'required-cookies',
      required: true
    }
  ],
  categories: [
    {
      name: 'required-cookies',
      apps: ['required-cookies']
    }
  ]
}

export const getOrejimeConfig = (privacyPolicyUrl, googleAnalytics, cookiesConfiguration) => {
  const state = localStorage.getItem('state')

  let gtmId = googleAnalytics
  let privacyPolicy = privacyPolicyUrl
  let customConfig = cookiesConfiguration && JSON.parse(cookiesConfiguration)

  if (!privacyPolicy && state) {
    const { campaign } = JSON.parse(state).configuration
    privacyPolicy = campaign && campaign.privacyPolicyUrl
  }
  if (!privacyPolicy) return null

  if (!gtmId && state) {
    const { campaign } = JSON.parse(state).configuration
    gtmId = campaign && campaign.googleAnalyticsId
  }

  if (!customConfig && state) {
    const { campaign } = JSON.parse(state).configuration
    customConfig = campaign && campaign.theme.cookiesConfiguration
  }

  const orejimeConfig = { ...defaultConfig, ...customConfig }

  return gtmId
    ? {
        ...orejimeConfig,
        privacyPolicy,
        apps: [
          ...orejimeConfig.apps,
          {
            name: 'google-tag-manager',
            cookies: [
              '_ga',
              '_gat',
              '__utma',
              '__utmb',
              '__utmc',
              '__utmt',
              '__utmz',
              '__gads',
              '_drt_',
              'FLC',
              'exchange_uid',
              'id',
              'fc',
              'rrs',
              'rds',
              'rv',
              'uid',
              'UIDR',
              'UID',
              'clid',
              'ipinfo',
              'acs'
            ],
            callback: consent => {
              if (consent) {
                const tagManagerArgs = {
                  gtmId
                }
                TagManager.initialize(tagManagerArgs)
              }
            }
          }
        ],
        categories: [
          ...orejimeConfig.categories,
          {
            name: 'apis',
            apps: ['google-tag-manager']
          }
        ]
      }
    : { ...orejimeConfig, privacyPolicy }
}

export const getOrejimeCookies = () => {
  const cookies = new Cookies()
  return cookies.get('orejime')
}

export const initOrejime = (privacyPolicyUrl, googleAnalytics, cookiesConfiguration) => {
  const orejimeConfig = getOrejimeConfig(privacyPolicyUrl, googleAnalytics, cookiesConfiguration)

  if (orejimeConfig) Orejime.init(orejimeConfig)
}
